import React, { forwardRef, useEffect, useMemo, useState } from "react";
import ReactSelect from "react-select";

import useSelectTheme from "../../../hooks/useSelectTheme";
import { useUserSearchSelect } from "../../hooks/useUserSearchSelect";

type SelectOption = { label: string; value: string };

type UserSelectProps = {
  userIds: string[] | undefined;
  disabled?: boolean;
  onSelect: (options: string[]) => void;
  customStyles?: Record<string, any>;
  idsToExclude?: string[];
  placeholder?: string;
};

const UserSelect: React.ForwardRefRenderFunction<any, UserSelectProps> = (
  { userIds, onSelect, customStyles, placeholder, idsToExclude = [] },
  ref
) => {
  const [theme, styles] = useSelectTheme(customStyles);
  const { users, loading, onInputChange } = useUserSearchSelect({
    excludeUserIds: idsToExclude,
    signUpCompleted: false,
  });
  const [selected, setSelected] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (!userIds?.length) {
      setSelected([]);
    }
  }, [userIds]);

  const sortedOptions = useMemo(() => {
    if (!users.length) return [];
    return [...users]
      .sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""))
      .map((u) => ({
        label: `${u.fullName} - ${u.email}`,
        value: u.id,
      }));
  }, [users]);

  return (
    <ReactSelect
      ref={ref}
      theme={theme}
      styles={styles}
      value={selected}
      isMulti
      isLoading={loading}
      options={sortedOptions}
      closeMenuOnSelect={false}
      placeholder={placeholder}
      filterOption={() => true}
      onInputChange={onInputChange}
      onChange={(value) => {
        const opts = Array.isArray(value) ? value : [];
        setSelected(opts);
        onSelect(opts.map((o) => o.value));
      }}
    />
  );
};

export default forwardRef(UserSelect);
